import { styled } from "@mui/material/styles";
import Icon from "@mui/material/Icon";
import ListItem from "@mui/material/ListItem";
import { useFormContext } from "react-hook-form";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import Divider from "@mui/material/Divider";

const StyledListItem = styled(ListItem)(({ theme, completed }) => ({
	...(completed && {
		background: "rgba(0,0,0,0.03)",
		"& .address-title, & .address": {
			textDecoration: "line-through",
		},
	}),
}));

function AddressListItem({ address, onChange }) {
	const { setValue, watch } = useFormContext();
	const selectedId = watch("address.id");
	const selected = selectedId === address.id;

	const handleSelect = () => {
		setValue("address.id", address.id, { shouldValidate: true });
		if (onChange) {
			onChange(address);
		}
	};

	return (
		<>
			<StyledListItem
				className="px-0 sm:px-8"
				onClick={handleSelect}
				dense
				button
			>
				{selected ? (
					<Icon color="secondary" className="fa-solid fa-circle-check" />
				) : (
					<Icon color="action" className="fa-solid fa-circle" />
				)}

				<div className="flex flex-1 flex-col relative overflow-hidden px-8">
					<Typography
						className="address-title truncate text-14 font-medium"
						color={selected ? "textSecondary" : "inherit"}
					>
						{address.firstName} {address.lastName}
					</Typography>

					<Typography color="textSecondary" className="address">
						{address.addressLine1} {address.addressLine2} {address.city},{" "}
						{address.state.code} {address.zipCode}
					</Typography>
				</div>
			</StyledListItem>

			<Divider className="my-5" />
		</>
	);
}

export default AddressListItem;
